import moment from "moment";

export const formatDate = (date) => {
    const convertedDate = new Date(date);
    return `${convertedDate?.getDate() < 10 ? "0" + convertedDate?.getDate() : convertedDate?.getDate()}-${convertedDate?.getMonth() < 10 ? "0" + (convertedDate?.getMonth() + 1) : (convertedDate?.getMonth() + 1)}-${convertedDate?.getFullYear()}`
}

export const showFullDate = (date) => {
    return moment(date).format("D MMMM YYYY , h:mm A");
}

export const formatDateTime = (date) => {
    return moment(date).format("DD-MM-YYYY - hh:mm A");
};

export const textCapital = (value) => {
    const stringData = String(value)?.split(" ")
    const data = stringData?.map((value) => {
        if (value !== "" && value !== " " && value !== undefined) {
            return `${value[0]?.toUpperCase()}${value.slice(1, (value.length))?.toLowerCase()}`
        }
    })
    return data?.join(" ")
}
export const hourBetweenDate = (date1, date2) => {
    const hours = ((new Date(date2)).valueOf() - (new Date(date1)).valueOf()) / 1000 / 60 / 60
    if (hours > 0) {
        return { status: true, hours: Math.ceil(hours) }
    } else {
        return { status: false }
    }
}
export const parseDateString = (dateString) => {
    if (dateString !== undefined && dateString !== "") {
        const [day, month, year] = dateString?.split('-')?.map(Number);
        return new Date(Date.UTC(year, month - 1, day));
    } else {
        return false
    }
}

export const isTrimmed = (str) => {
    return !(str == str.trim());
}

export const setCookie = (name, storevalue) => {
    document.cookie = name + "=" + storevalue + "; path=/";;
}
export const setCookieWithExpiry = (name, storevalue, expirydays) => {
    const d = new Date();
    d.setTime(d.getTime() + (expirydays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + storevalue + ";" + expires + ";path=/";
}
export const getCookie = (name) => {
    let get_name = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(get_name) == 0) {
            return c.substring(get_name.length, c.length);
        }
    }

    return "";
}
export const removeCookie = (name) => {
    document.cookie = name + "=";
}
export const deleteAllCookies = () => {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
}
export const storageSetItem = (key, value) => {
    return window.localStorage.setItem(key, JSON.stringify(value));
}
export const storageGetItem = (key) => {
    return JSON.parse(window.localStorage.getItem(key));
}
export const storageRemoveItem = (key) => {
    return window.sessionStorage.removeItem(key);
}
export const storageRemoveAll = () => {
    return window.sessionStorage.clear();
}
export const sessionStorageSetItem = (key, value) => {
    return window.sessionStorage.setItem(key, JSON.stringify(value));
}
export const sessionStorageGetItem = (key) => {
    return JSON.parse(window.sessionStorage.getItem(key));
}
export const sessionStorageRemoveItem = (key) => {
    return window.sessionStorage.removeItem(key);
}
export const sessionStorageRemoveAll = () => {
    return window.sessionStorage.clear();
}
export const currencyFormatter = (amount, code) => {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: code }).format(amount);
}
export const showTimeZoneDate = (date) => {
    if (date === "" || date === undefined || date === null || date === "-") { return ""; }
    var date = moment(date);
    return moment.utc(date).local().format("DD-MM-YYYY h:mm a");
}
export const showZoneDate = (date) => {
    if (date === "" || date === undefined || date === null || date === "-") { return ""; }
    var date = moment(date);
    return moment.utc(date).local().format("DD-MM-YYYY");
}
export const getFromToDate = (date) => {
    if (date === "" || date === undefined || date === null || date === "-") { return ""; }
    var date = moment(date);
    return moment.utc(date).local().format("YYYY-MM-DD");
}
export const showZoneTime = (time) => {
    if (time === "" || time === undefined || time === null || time === "-") { return ""; }
    var time = moment(time);
    return moment.utc(time).local().format("h:mm a");
}
export const textCapitalize = (data) => {
    if (data !== undefined && data !== null && data !== "") {
        return data.charAt(0).toUpperCase() + data.slice(1);
    } else {
        return data;
    }
}
export const returnFirstDegreeObjValue = (obj, key) => {
    return obj && (obj[key] || obj[key] === 0) ? obj[key] : "N/A";
}
export const returnSecondDegreeObjValue = (obj, key, postion) => {
    if (obj && obj[key] && (obj[key][postion] || obj[key][postion] === 0))
        return obj[key][postion];
    else return "N/A";
}
export const returnThirdDegreeObjValue = (masterobj, obj, key, postion) => {
    if (
        masterobj &&
        masterobj[obj] &&
        masterobj[obj][key] &&
        (masterobj[obj][key][postion] || masterobj[obj][key][postion] === 0)
    )
        return masterobj[obj][key][postion];
    else return "N/A";
}
export const returnFourthDegreeObjValue = (masterobj, obj, key, postion, fourthObj) => {
    if (
        masterobj &&
        masterobj[obj] &&
        masterobj[obj][key] &&
        masterobj[obj][key][postion] &&
        (masterobj[obj][key][postion][fourthObj] || masterobj[obj][key][postion][fourthObj] === 0)
    )
        return masterobj[obj][key][postion][fourthObj];
    else return "N/A";
}
export const returnFifthDegreeObjValue = (masterobj, obj, key, postion, fourthObj, fifthObj) => {
    if (
        masterobj &&
        masterobj[obj] &&
        masterobj[obj][key] &&
        masterobj[obj][key][postion] &&
        masterobj[obj][key][postion][fourthObj] &&
        (masterobj[obj][key][postion][fourthObj][fifthObj] || masterobj[obj][key][postion][fourthObj][fifthObj] === 0)
    )
        return masterobj[obj][key][postion][fourthObj][fifthObj];
    else return "N/A";
}
export const parseJson = (jsondata) => {
    return JSON.parse(jsondata);
}
export const stringifyJson = (jsondata) => {
    return JSON.stringify(jsondata);
}
export const reloadWindow = () => {
    return window.location.reload();
}
export const reloadWindowToPath = (pathtoload) => {
    return window.location.href = pathtoload;
}

// export const encryptPassword = (password) => {
//     const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
//     const iv = CryptoJS.lib.WordArray.random(16);
//     const encrypted = CryptoJS.AES.encrypt(
//         password,
//         CryptoJS.enc.Utf8.parse(encryptionKey),
//         {
//             iv: iv,
//         }
//     ).toString();
//     const encryptedWithIv = iv.toString(CryptoJS.enc.Hex) + encrypted;
//     return encryptedWithIv;
// };

// export const decryptedData = (encryptedData) => {
//     try {
//         const ivHex = encryptedData?.substring(0, 32);
//         const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
//         const iv = CryptoJS.enc.Hex.parse(ivHex);
//         const encryptedText = encryptedData?.substring(32);
//         const decrypted = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Hex.parse(encryptionKey),
//             {
//                 iv: iv,
//                 mode: CryptoJS.mode.CBC,
//                 padding: CryptoJS.pad.Pkcs7,
//             }
//         );
//         const data = decrypted.toString(CryptoJS.enc.Utf8);
//         return JSON.parse(data);
//     } catch (err) {
//         return encryptedData;
//     }
// }

export const copyContent = async (content) => {
    await navigator?.clipboard?.writeText(content);
}

export function removeEmptyKeys(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !obj[key]?.trim()) {
            delete obj[key];
        }
    }
    return obj;
}


export const toReadableTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    let result = [];

    if (hrs > 0) result.push(`${hrs} hour`);
    if (mins > 0) result.push(`${mins} min`);
    if (secs > 0 || result.length === 0) result.push(`${secs} s`);

    return result.join(" ");
}

export const formatPhoneNo = (phone) => {
    let phoneNo = String(phone)
    if (phoneNo.length == 12) {
        return phoneNo.slice(2,)
    } else {
        return phoneNo
    }
}


// DOB can come as DD-MM-YYYY, DD/MM/YYYY, YYYY-MM-DD, YYYY/MM/DD, an ISO string or a Date - returns a local Date or null
export const parseDob = (value) => {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    if (typeof value !== "string") return null;
    const v = value.trim();
    let m = v.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:$|[T\s])/);
    let y, mo, d;
    if (m) { [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])]; }
    else if ((m = v.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/))) { [d, mo, y] = [Number(m[1]), Number(m[2]), Number(m[3])]; }
    else { const t = new Date(v); return isNaN(t.getTime()) ? null : t; }
    const date = new Date(y, mo - 1, d);
    return date.getFullYear() === y && date.getMonth() === mo - 1 && date.getDate() === d ? date : null;
};
export const formatDob = (value) => {
    const d = parseDob(value);
    return d ? `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}` : (value || "");
};

// KYC photo upload: admin always, subadmin until verified, and anyone when the KYC is verified but this photo is missing
export const canUploadKyc = (person, verified, photo) =>
    person === "admin" || (person === "subadmin" && !verified) || (!!verified && !(typeof photo === "string" && photo));